import { useMediaQuery, useTheme } from "@material-ui/core";
import { memo } from "react";

// data
import { SectionProps } from "../types/types";
import MobileContactUsSection from "./mobile/MobileContactUsSection";
import WebContactUsSection from "./web/WebContactUsSection";

function ContactUsSection({
  setActiveSection,
  setLoadedSections,
  loadedSections,
}: SectionProps) {
  const theme = useTheme();
  const mobileView = useMediaQuery(theme.breakpoints.down("xs"));

  return mobileView ? (
    <MobileContactUsSection />
  ) : (
    <WebContactUsSection
      setActiveSection={setActiveSection}
      setLoadedSections={setLoadedSections}
      loadedSections={loadedSections}
    />
  );
}

export default memo(ContactUsSection);
